import React, { useContext } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { RootStoreContext } from "../../../app/stores/rootStore";
import NewSeller from "./NewSeller";
import ListSellers from "./ListSellers";

interface IProps {
  sections: any[];
}

const DashboardClient: React.FC<IProps> = ({ sections }) => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  document.title = "Vendedores";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Vendedores" sections={sections} />
      <Segment >
        <Button
          onClick={() => openModal(<NewSeller />, "Crear vendedor")}
          color="blue"
        >
          <Icon name="add user" /> Agregar Vendedor
        </Button>
        <br />
        <br />
        <ListSellers/>
      </Segment>
    </div>
  );
};

export default observer(DashboardClient);
